module.exports = __webpack_public_path__ + "static/media/logo-inteira.bdf3229f.png";